import React from 'react';
import { Card as MuiCard, CardContent, CardHeader } from '@mui/material';

// 卡片
export default function Card(props: {
    // 卡片标题
    title?: string | JSX.Element;
    // 按钮
    actionRender?: JSX.Element;
    // 内容
    contentRender?: JSX.Element;
    contentClassName?: string;
    className?: string;
    /** 透传 CardHeader 标题 Typography 属性（MUI5 泛型较严，此处放宽为 Record） */
    titleTypographyProps?: Record<string, unknown>;
}) {
    const { title, actionRender, contentRender, contentClassName, className, titleTypographyProps } = props;
    return (
        <MuiCard className={className} elevation={2}>
            {
                title &&
                <CardHeader
                    action={actionRender}
                    title={title}
                    titleTypographyProps={titleTypographyProps}
                />
            }
            <CardContent className={contentClassName ?? ''}>
                {contentRender}
            </CardContent>

        </MuiCard>
    )
}